import { formatChemicalCompoundNameAsUnicode } from "@omnia/shared/utils/format";
import { INtrReqNutrients, isNumber, param } from "./omnia"
import { INtrApp, INtrNutrients } from "./types"

export const nutrients = param.NutrientType().map(n => {
    return {
        text: formatChemicalCompoundNameAsUnicode(n.text),
        value: n.value
    }
})

const _nutrients = ["N", "SO3", "P2O5", "K2O", "MgO", "Lime"];

export function getRequirementsNutrients(req: INtrReqNutrients): INtrNutrients {

    if (req) {

        return {

            N: req.RequiredN,
            SO3: req.RequiredSO3,

            P2O5: req.RequiredP2O5,
            K2O: req.RequiredK2O,
            MgO: req.RequiredMgO,

            Lime: req.RequiredLime,

        }

    };

    return {};

}

export function addNutrients(nutrients: INtrNutrients[]): INtrNutrients {

    return nutrients.reduce((n1, n2) => {

        return _nutrients.reduce((target, key) => {

            let v1 = n1[key];
            let v2 = n2[key];
            // let rounding = (key == "Lime" ? 10 : 1);
            const rounding = 1;

            if (isNumber(v1) || isNumber(v2)) {
                let value = (v1 || 0) + (v2 || 0);
                value = Math.round(value * rounding) / rounding;
                target[key] = value;
            }

            return target;

        }, {});

    }, {});


}

export function getRequirementsLeft(requirements: INtrNutrients, application: INtrNutrients): INtrNutrients {

    return _nutrients.reduce((target, key) => {

        let value = requirements[key];
        // let rounding = (key == "Lime" ? 10 : 1);
        const rounding = 1;

        if (isNumber(value)) {
            value -= (application[key] || 0);
            value = Math.round(value * rounding) / rounding;
            target[key] = value;
        }

        return target;

    }, {});


}

export function getAppNutrients(app: INtrApp): INtrNutrients {

    return _nutrients.reduce((target, key) => {
        target[key] = app[key];
        return target;
    }, {});

}

export function calculateAverageContrib(sources: { area: number, contrib: INtrNutrients }[]): INtrNutrients {

    let contrib = sources.filter(c => !!c.contrib).map(c => {
        return {
            area: c.area,
            nutrients: c.contrib
        }
    });

    return calculateAverageNutrients(contrib);

}

export function calculateAverageNutrients(parts: { nutrients: INtrNutrients, area: number }[]) {

    if (!parts || (!parts.length)) return null;
    if (parts.length == 1) return parts[0].nutrients;

    let totalArea = parts.reduce((a, p) => a + p.area, 0);

    function avg(key: string) {
        return Math.round(parts.map(p => (p.nutrients[key] || 0) * p.area).reduce((r1, r2) => r1 + r2) / totalArea)
    }

    let average: INtrNutrients = {
        N: avg("N"),
        SO3: avg("SO3"),
        P2O5: avg("P2O5"),
        K2O: avg("K2O"),
        MgO: avg("MgO"),
        Lime: avg("Lime")
    }

    return average;

}
